import { useMemo, useRef } from "react";
import { estadosDesignacion } from "../../config/constants";
import * as yup from 'yup';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormDesignacionEnviarRevision } from "../abm/designaciones/FormDesignacionEnviarRevision";

const getSchema = () => yup.object().shape({
  id: yup.number().required(),
  estado: yup.string().label("Estado").required(), 
  observacion: yup.string().label("Observacion").max(255), 
});

export const ModalDesignacionEnviarRevision = ({showState = [false, ()=>{}], selectedItem, abmActions, showNotification, updateItem, id = selectedItem?.id}) => {

  const [show, setShow] = showState;
  const formRef = useRef();
  const schema = useMemo(() => getSchema(), []);

  const handleCancel = (event) => {
    setShow(false);
    event?.preventDefault();
    event?.stopPropagation();
  }
   
  const handleConfirm = (data) => {
    abmActions.update(data, id, "designaciones/estado").then(result => {
      updateItem(id);
      setShow(false);
    }).catch(error=>{
      error.json().then(result => {
        showNotification({message: result.messages.map(m => <div className="notification-item">{m}</div>) || "Error creando registro"});
      })
    });
  }

  return (
    <Dialog open={show} onClose={handleCancel} PaperProps={{sx: {overflow: "visible"}}}>
      <DialogTitle>Enviar a revisión la designación</DialogTitle>
      <DialogContent sx={{overflow: "visible"}}>
        <FormDesignacionEnviarRevision 
          ref={formRef}
          item={{
            id,
            estado: estadosDesignacion.EN_REVISION
          }}
          schema={schema} 
          onConfirm={handleConfirm} 
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="success" onClick={e => formRef.current.submit(e)}>
          Guardar
        </Button>      
        <Button variant="outlined" color="error" onClick={handleCancel}>
          Cancelar
        </Button>   
      </DialogActions>
    </Dialog>
  )
}